<template>
  <vs-row>
    <vs-col vs-lg="6" vs-xs="12" class="p15 vs-input-primary">
      <label class="vs-input--label">Address</label>
      <vue-google-autocomplete
        id="map"
        classname="vs-inputx vs-input--input normal"
        placeholder="Google Address"
        :country="['in']"
        v-on:placechanged="getAddressData"
        v-model="a.add"
        @change="updateAddress"
      >
      </vue-google-autocomplete>
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input label="Landmark" v-model="a.landmark" @change="updateAddress" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input label="City" v-model="a.city" @change="updateAddress" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input label="State" v-model="a.state" @change="updateAddress"
    /></vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input label="Pin Code" v-model="a.zip" @change="updateAddress"
    /></vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input label="Country" v-model="a.country" @change="updateAddress" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input label="Latitude" v-model="a.lat" @change="updateAddress"
    /></vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input label="Longitude" v-model="a.lng" @change="updateAddress" />
    </vs-col>
    <vs-col vs-lg="12" vs-xs="12">
      <vs-input label="Map URL" v-model="a.mapUrl" @change="updateAddress" />
    </vs-col>
  </vs-row>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  name: "GoogleAddress",
  components: {
    VueGoogleAutocomplete,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {
          street: "",
          add: "",
          landmark: "",
          state: "",
          stateCode: "",
          city: "",
          country: "",
          countryCode: "",
          lat: "",
          lng: "",
          zip: "",
          mapUrl: "",
          utc_offset: "",
        };
      },
    },
  },
  data: () => ({
    a: {
      street: "",
      add: "",
      landmark: "",
      state: "",
      stateCode: "",
      city: "",
      country: "",
      countryCode: "",
      lat: "",
      lng: "",
      zip: "",
      mapUrl: "",
      utc_offset: "",
    },
  }),
  methods: {
    /* eslint-disable */
    getAddressData: function(addressData, placeResultData, id) {
      if (placeResultData !== undefined) {
        placeResultData.address_components.forEach((element) => {
          if (element.types.indexOf("locality") >= 0) {
            // city
            this.$data.a.city = element.long_name;
          }
          if (element.types.indexOf("administrative_area_level_1") >= 0) {
            // state
            this.$data.a.state = element.long_name;
            this.$data.a.stateCode = element.short_name;
          }
          if (element.types.indexOf("country") >= 0) {
            // country
            this.$data.a.country = element.long_name;
            this.$data.a.countryCode = element.short_name;
          }
          if (element.types.indexOf("postal_code") >= 0) {
            // zipcode
            this.$data.a.zip = element.long_name;
          }
          if (element.types.indexOf("street_number") >= 0) {
            // street
            this.$data.a.street = element.long_name;
          }
        });
        this.$data.a.add = placeResultData.formatted_address;
        this.$data.a.lat = placeResultData.geometry.location.lat();
        this.$data.a.lng = placeResultData.geometry.location.lng();
        this.$data.a.mapUrl = placeResultData.url + "&output=embed";
        this.$data.a.utc_offset = placeResultData.utc_offset_minutes;
      }
      this.$emit("input", {
        address: this.$data.a,
        latitude: this.$data.a.lat + "",
        longitude: this.$data.a.lng + "",
        mapUrl: this.$data.a.mapUrl + "&output=embed",
      });
    },
    updateAddress() {
      this.$emit("input", {
        address: this.$data.a,
        latitude: this.$data.a.lat + "",
        longitude: this.$data.a.lng + "",
        mapUrl: this.$data.a.mapUrl + "&output=embed",
      });
    },
  },
  created() {
    this.$events.on("reset", (e) => {
      this.$data.a = {};
      this.$data.a.add = "";
    });
  },
};
</script>
<style scoped>
.p15 {
  padding-bottom: 15px;
}
</style>
